import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import api from "../../api";

import { Row, Col } from 'reactstrap';

import ParadigmaModal from "../../components/ParadigmaModal/ParadigmaModal.js"
import ParadigmaAsyncSeeker from "../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaLabeledInput from "../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"


class PerfilEntidad extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            nombre: '',
            direccion: '',
            email: '',
            tipoEntidad_id: null,

            postVariables: ['nombre', 'direccion', 'email', 'tipoEntidad'],
            errors: [],
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        id: PropTypes.func,
        action: PropTypes.oneOf(['CREATE', 'EDIT', 'DETAIL', 'DELETE', 'VIEW']).isRequired,
    }


    resetForm() {
        this.setState({
            id: null,
            nombre: '',
            direccion: '',
            email: '',
            tipoEntidad_id: null,

            errors: [],
        });
    }

    getData() {
        const { postVariables } = this.state;
        let data = {};
        postVariables.forEach(x => {
            if (x === 'tipoEntidad') {
                data['tipoEntidad'] = this.state.tipoEntidad_id;
            } else {
                data[x] = this.state[x];
            }
        });

        return data;
    }

    setData(data) {
        if (data.success) {
            this.setState({
                id: data.id,
                nombre: data.nombre,
                direccion: data.direccion || '',
                email: data.email || '',
                tipoEntidad_id: (data.tipoEntidad) ? (data.tipoEntidad.id) : (null),
            });
        }
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    onValidation = () => {
        const { nombre, email } = this.state;

        let error = {};
        let validate = true;
        
        if (email && ((email.indexOf("@") == -1) || (email.indexOf(".") == -1) || (email.indexOf("@") > email.lastIndexOf(".")) || (email.lastIndexOf(".") == email.length-1))){
            error.email = [{code: "required", detail: "Ingrese un email valido"}];
            validate = false;
        }

        if(nombre.length<2){
            error.nombre = [{code: "required", detail: "Ingrese un nombre valido"}];
            validate = false;
        }

        this.setState({
            errors: error,
        })

        return validate;

    }

    render() {
        const { action } = this.props;
        const { nombre, direccion, email, tipoEntidad_id } = this.state;
        const isViewMode = action === 'VIEW';

        return (
            <ParadigmaModal
                navButton={true}
                nav={({
                    name: 'Perfil',
                    icon: 'fa fa-user',
                    tag: 'button',
                    className: 'dropdown-item'
                })}

                getUrl={api.comitentes.perfilentidades}
                submitUrl={api.comitentes.perfilentidades}
                submitType={"PUT"}

                onOpen={() => (this.props.onOpen ? this.props.onOpen() : null)}
                onGotData={(data) => this.setData(data)}
                onClose={() => { (this.props.onClose ? this.props.onClose() : null); this.resetForm(); }}
                onValidation={() => this.onValidation()}
                onGotErrors={(errors) => this.setErrors(errors)}
                onCleanForm={() => this.resetForm()}
                onPreSubmit={() => this.getData()}

                title={"Perfil"}

                successMessage={"La Entidad ha sido editada con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}

                saveButton={!isViewMode}
                closeButton={true}
                className="modal-tabs"

                escClose={true}
            >

                <ParadigmaLabeledInput
                    md={[2, 10]}
                    label={"Nombre"}
                    value={nombre}
                    maxLength={100}
                    onChange={(e) => this.onChangeField('nombre', e.target.value)}
                    error={() => this.getError('nombre')}
                    disabled={isViewMode}
                />

                <ParadigmaLabeledInput
                    md={[2, 10]}
                    label={"Dirección"}
                    value={direccion}
                    maxLength={100}
                    onChange={(e) => this.onChangeField('direccion', e.target.value)}
                    error={() => this.getError('direccion')}
                    disabled={isViewMode}
                />

                <ParadigmaLabeledInput
                    md={[2, 10]}
                    label={"Email"}
                    value={email}
                    maxLength={150}
                    onChange={(e) => this.onChangeField('email', e.target.value)}
                    error={() => this.getError('email')}
                    disabled={isViewMode}
                />

                <ParadigmaLabeledInput
                    md={[2, 10]}
                    label={"Tipo de Entidad"}
                    inputComponent={
                        <ParadigmaAsyncSeeker
                            clearable={false}
                            disabled={isViewMode}
                            url={api.comitentes.tiposEntidadesSelect}
                            value={tipoEntidad_id}
                            parameters={{
                                paginationEnabled:false,
                                sort:['nombre'],
                            }}
                            onChange={(data) => this.onChangeField('tipoEntidad_id', (data ? data.id : null))}
                        />
                    }
                    error={() => this.getError('tipoEntidad_id')}
                    disabled={isViewMode}
                />

            </ParadigmaModal>
        );
    }
}

export default PerfilEntidad;



// WEBPACK FOOTER //
// ./src/views/PerfilEntidad/PerfilEntidad.js